import * as React from "react";
import { SVGProps, memo } from "react";

const SvgStepperCurrentStep = (props: SVGProps<SVGSVGElement>) => (
  <svg width={19} height={18} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M17.5 9a8 8 0 1 1-16 0 8 8 0 0 1 16 0Z" stroke="#4DB27F" strokeWidth={2} />

    <path d="M15.5 9a6 6 0 1 1-12 0 6 6 0 0 1 12 0Z" fill="#4DB27F" stroke="#fff" strokeWidth={2} />
  </svg>
);

const Memo = memo(SvgStepperCurrentStep);

export default Memo;
